import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../../constants';

import { formatAmountCurrency } from '../../../../utils/index';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import SvgComponent from '../../../SvgComponent';
import CashbackByStatusComponent from './CashbackByStatusComponent';

class ResumeCashbackComponent extends React.Component {
    render() {
        const { i18n, totalCashback, leftAmount, rightAmount } = this.props;

        return (
            <div className="resumeCagnotte">
                <div className="totalCagnotte">
                    {convertHtmlToReactDomWithParams(
                        i18n.JACKPOT,
                        formatAmountCurrency(totalCashback)
                    )}
                </div>
                <CashbackByStatusComponent
                    cssClass="valid"
                    amount={leftAmount}
                    txt={i18n.VALID_CASHBACK}
                    svg="debit_transmission"
                />
                <div className="croixResumeCagnotte">
                    <SvgComponent
                        src={`${STATIC_ROOT}/croix.svg`}
                        width="30"
                        height="30"
                        aria-hidden="true"
                        focusable="false"
                    />
                </div>
                <CashbackByStatusComponent
                    cssClass="pending"
                    amount={rightAmount}
                    txt={i18n.WAITING_CASHBACK}
                    svg="debit_scheduled"
                />
            </div>
        );
    }
}

ResumeCashbackComponent.propTypes = {
    totalCashback: PropTypes.number.isRequired,
    leftAmount: PropTypes.number.isRequired,
    rightAmount: PropTypes.number.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT
    };
}

export default connect(mapStateToProps)(ResumeCashbackComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/ResumeCashbackComponent.js